import { render, staticRenderFns } from "./text_static.vue?vue&type=template&id=2d4791df"
import script from "./text_static.vue?vue&type=script&lang=ts"
export * from "./text_static.vue?vue&type=script&lang=ts"
import style0 from "./text_static.vue?vue&type=style&index=0&id=2d4791df&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports